"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isENSName = void 0;
const ENSName_1 = require("./ENSName");
function isENSName(domain) {
    return (0, ENSName_1.isENSNameFormatIgnoreCase)(domain);
}
exports.isENSName = isENSName;
//# sourceMappingURL=isENSName.js.map